import store from '@shared/store/index';

export const initColorTheme = () => {
  store.dispatch('ColorThemesManager/initTheme');
}